export default __webpack_public_path__ + "40077f53f837ba1378f4ff39207bf86a.png";